const isProd = true;

export const API_BASE_URL = isProd
  ? "https://api.solanitor.com"
  : "http://localhost:7777";

 export const DOMAIN = isProd ? ".solanitor.com" : "localhost";